import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class AuthApi extends BaseApi {
  async postVerifyNewEmail(
    requestBody: APIPaths["/operator-dash/auth/verify-new-email"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/operator-dash/auth/verify-new-email"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/operator-dash/auth/verify-new-email", requestBody)).data;
  }
  async postLogin(
    requestBody: APIPaths["/operator-dash/auth/login"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/operator-dash/auth/login"]["post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post("/operator-dash/auth/login", requestBody)).data;
  }
  async postRenewToken(): Promise<
    APIPaths["/operator-dash/auth/renew-token"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/operator-dash/auth/renew-token")).data;
  }
  async postResetPassword(
    requestBody: APIPaths["/operator-dash/auth/reset-password"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/operator-dash/auth/reset-password"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/operator-dash/auth/reset-password", requestBody)).data;
  }
}
